import { useQuery, UseQueryOptions } from '@tanstack/react-query'

import { QUERY_KEYS } from '~constants'
import { getRedeemedCoupons, writeToStorageCacheQuery } from '~services'
import { PurchaseHistoryResponse } from '~types/user'
import { useGetQueryState } from '~utils'

const { REDEEMED_COUPONS } = QUERY_KEYS

const redeemedCouponsQueryKey = [REDEEMED_COUPONS] as [string]

export function useRedeemedCoupons(
  options?: UseQueryOptions<PurchaseHistoryResponse, unknown, PurchaseHistoryResponse>
) {
  const cachedData = useGetQueryState<PurchaseHistoryResponse>(redeemedCouponsQueryKey)

  const {
    isLoading: isFetchingRedeemedCoupons,
    refetch: refetchRedeemedCoupons,
    data,
  } = useQuery<PurchaseHistoryResponse>(redeemedCouponsQueryKey, getRedeemedCoupons, {
    keepPreviousData: true,
    onSuccess: (data) => {
      writeToStorageCacheQuery(redeemedCouponsQueryKey, data)
    },
    ...options,
  })

  return {
    redeemedCoupons: cachedData?.items || data?.items || [],
    total: cachedData?.total || data?.total || 0,
    isFetchingRedeemedCoupons,
    refetchRedeemedCoupons,
  }
}

useRedeemedCoupons.queryKey = () => redeemedCouponsQueryKey

